export default __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmEU9fCRc4AMP6lbBP.92ac7c0c.woff2";